import { memo } from 'react'
import { Link, Typography } from '@mui/material'
import useStore from 'stores/utils/hooks/useStore'

const AgbText = ({
  ctaButtonLabel = 'Weiter'
}: {
  ctaButtonLabel?: string
}) => {
  const clientDetails = useStore(
    (store) => store.clientDetailsStore?.clientDetails
  )

  return (
    <>
      <Typography variant="caption" sx={{ fontSize: '0.875rem' }}>
        {`Mit Klick auf den "${ctaButtonLabel}"-Button akzeptiere ich die`}{' '}
        <Link
          href={clientDetails?.urls?.termsAndConditions}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          AGB
        </Link>{' '}
        und erteile smava einen kostenlosen Kreditvergleichsauftrag. Ich habe
        die{' '}
        <Link
          href={clientDetails?.urls?.precontractual}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          Pflichtinformationen
        </Link>{' '}
        und die{' '}
        <Link
          href={clientDetails?.urls?.dataProtection}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          Datenschutzhinweise
        </Link>{' '}
        erhalten.
      </Typography>
    </>
  )
}

export default memo(AgbText)
